"use client";

import React from "react";

import Typography from "@mui/material/Typography";

import { getTestAutomationProps } from "~/helpers/test-automation-props";

import { CopyrightContainer } from "./styled";

interface CopyrightProps {
  copyrightText: string;
}

export const Copyright: React.FC<CopyrightProps> = ({ copyrightText }) => {
  return (
    <CopyrightContainer>
      <Typography variant="body2" {...getTestAutomationProps("copyright")}>
        {copyrightText}
      </Typography>
    </CopyrightContainer>
  );
};
